export const newspaperInitialState = {};
